module.exports = __webpack_public_path__ + "static/media/22.be8d2c18.png";